'use client';
import { Textarea as BaseTextarea } from '@lichtblick/photon/molecules/textarea/textarea';
import { withValidation } from './Form.helpers';
export const Textarea = withValidation(BaseTextarea);

//# sourceMappingURL=Textarea.js.map